import VerificationFailedModal from './VerificationFailedModal';
export default VerificationFailedModal;